import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

export const TextWrapper = styled.div`
  display: flex;
  max-width: 350px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const Title = styled.div`
  width: 280px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
